import React, { useEffect } from "react";
import { Switch, Route } from "react-router-dom";

// routes
import {
  AccessRoute,
  AuthProtected,
  PublicRoutes,
  SuperAdminRoutes,
  TeacherAdminRoutes,
} from ".";

// layouts
import Layout from "../layouts/Layout";
import { NonAuthLayout } from "../layouts";
import { useSession } from "../components/Hooks/UserHooks";
import { useDispatch, useSelector } from "react-redux";
import { getUserProfile } from "../store/actions";
import { State, UserProfileDto } from "../interfaces";
import { RoleEnum } from "../enums";

export const AppRoutes = () => {
  const publicPaths = PublicRoutes.map((r: any) => r.path);
  const superAdminPaths = SuperAdminRoutes.map((r: any) => r.path);
  const teacherAdminPaths = TeacherAdminRoutes.map((r: any) => r.path);

  const { loading: loadingProfile, response: profile } = useSelector(
    (state: any): State<UserProfileDto> => state.account.userProfile
  );

  const { session, loading: loadingSession, token } = useSession();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!loadingSession && token && !loadingProfile) {
      dispatch(getUserProfile());
    }
  }, [loadingSession, token, session]);

  return (
    <React.Fragment>
      <Switch>
        <Route path={publicPaths}>
          <NonAuthLayout>
            <Switch>
              {PublicRoutes.map((route: any, idx: number) => (
                <Route
                  path={route.path}
                  component={route.component}
                  key={idx}
                  exact={true}
                />
              ))}
            </Switch>
          </NonAuthLayout>
        </Route>

        {profile && profile.role.key === RoleEnum.SUPER_ADMIN && (
          <Route path={superAdminPaths}>
            <AuthProtected>
              <Layout>
                <Switch>
                  {SuperAdminRoutes.map((route, idx) => (
                    <AccessRoute
                      path={route.path}
                      component={route.component}
                      key={idx}
                      exact={true}
                    />
                  ))}
                </Switch>
              </Layout>
            </AuthProtected>
          </Route>
        )}

        <Route path={teacherAdminPaths}>
          <AuthProtected>
            <Layout>
              <Switch>
                {TeacherAdminRoutes.map((route, idx) => (
                  <AccessRoute
                    path={route.path}
                    component={route.component}
                    key={idx}
                    exact={true}
                  />
                ))}
              </Switch>
            </Layout>
          </AuthProtected>
        </Route>
      </Switch>
    </React.Fragment>
  );
};
